import { render, staticRenderFns } from "./Testimonial2.vue?vue&type=template&id=80775b4a"
import script from "./Testimonial2.vue?vue&type=script&lang=js"
export * from "./Testimonial2.vue?vue&type=script&lang=js"
import style0 from "./Testimonial2.vue?vue&type=style&index=0&id=80775b4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports